import BftBooleanButton from "common/components/boolean-button";
import BftInput from "common/components/input";
import { BooleanValues } from "constants/global";
import { FormikErrors, FormikTouched } from "formik";
import { Col, Form, Row } from "react-bootstrap";
import { FormValues, SedeDtoExt } from "..";

const { FALSE } = BooleanValues;
interface Props {
	sedeIndex: number;
	values: FormValues;
	errors: FormikErrors<FormValues>;
	touched: FormikTouched<FormValues>;
	handleBlur: (e: React.FocusEvent<any, Element>) => void;
	handleChange: {
		(e: React.ChangeEvent<any>): void;
		<T = string | React.ChangeEvent<any>>(field: T): T extends React.ChangeEvent<any>
			? void
			: (e: string | React.ChangeEvent<any>) => void;
	};
}

const IndirizziContattiSedeItem: React.FC<Props> = (props) => {
	const {
		values: _values,
		sedeIndex,
		errors: _errors,
		touched: _touched,
		handleBlur,
		handleChange,
	} = props;

	const namePrefix = `elencoSedi[${sedeIndex}]`;
	const values = _values?.elencoSedi?.[sedeIndex];
	const errors =
		sedeIndex != undefined
			? (_errors?.elencoSedi?.[sedeIndex] as FormikErrors<SedeDtoExt>)
			: undefined;
	const touched =
		sedeIndex != undefined
			? (_touched?.elencoSedi?.[sedeIndex] as FormikTouched<SedeDtoExt>)
			: undefined;

	const handlePrepostoCheck = (value: string | undefined) => {
		if (value) handleChange(`${namePrefix}.prepostoIsRL`)(value);
	};

	return (
		<>
			<Form.Check
				className={`bft-radio ${values?.operativa ? "checked opened-preposto" : ""}`}
				type="checkbox"
				name={`${namePrefix}.operativa`}
				checked={values?.operativa}
				label={`${values?.indirizzo}${values?.numeroCivico ? " " + values?.numeroCivico : ""}, ${
					values?.cap
				} ${values?.comune} (${values?.provincia})`}
				onChange={handleChange}
			/>

			<input hidden name={`${namePrefix}.tipoSede`} defaultValue={values?.tipoSede} />

			{values?.operativa && (
				<div className="container-form-preposto">
					<BftBooleanButton
						label="L'operatore della sede coincide con il legale rappresentante?"
						name={`${namePrefix}.prepostoIsRL`}
						value={values?.prepostoIsRL}
						onChange={handlePrepostoCheck}
					/>
					{!!errors?.prepostoIsRL && touched?.prepostoIsRL && (
						<Form.Control.Feedback className="ms-3" type="invalid">
							{errors?.prepostoIsRL}
						</Form.Control.Feedback>
					)}

					{values?.prepostoIsRL == FALSE && (
						<Row className="mb-3">
							<Col md={6}>
								<BftInput
									required
									type={"text"}
									name={`${namePrefix}.nomeSoggettoPreposto`}
									placeholder={"Nome preposto*"}
									value={values?.nomeSoggettoPreposto?.toUpperCase()}
									onChange={handleChange}
									onBlur={handleBlur}
									isInvalid={!!errors?.nomeSoggettoPreposto && touched?.nomeSoggettoPreposto}
								/>
								{errors?.nomeSoggettoPreposto && touched?.nomeSoggettoPreposto && (
									<Form.Control.Feedback className="ms-3 mb-3" type="invalid">
										{errors?.nomeSoggettoPreposto}
									</Form.Control.Feedback>
								)}
							</Col>

							<Col md={6}>
								<BftInput
									required
									type={"text"}
									name={`${namePrefix}.cognomeSoggettoPreposto`}
									placeholder={"Cognome preposto*"}
									value={values?.cognomeSoggettoPreposto?.toUpperCase()}
									onChange={handleChange}
									onBlur={handleBlur}
									isInvalid={!!errors?.cognomeSoggettoPreposto && touched?.cognomeSoggettoPreposto}
								/>
								{errors?.cognomeSoggettoPreposto && touched?.cognomeSoggettoPreposto && (
									<Form.Control.Feedback className="ms-3 mb-3" type="invalid">
										{errors?.cognomeSoggettoPreposto}
									</Form.Control.Feedback>
								)}
							</Col>

							<Col md={6}>
								<BftInput
									required
									type={"text"}
									name={`${namePrefix}.emailSoggettoPreposto`}
									placeholder={"Email preposto*"}
									value={values?.emailSoggettoPreposto}
									onChange={handleChange}
									onBlur={handleBlur}
									isInvalid={!!errors?.emailSoggettoPreposto && touched?.emailSoggettoPreposto}
								/>
								{errors?.emailSoggettoPreposto && touched?.emailSoggettoPreposto && (
									<Form.Control.Feedback className="ms-3 mb-3" type="invalid">
										{errors?.emailSoggettoPreposto}
									</Form.Control.Feedback>
								)}
							</Col>

							<Col md={6}>
								<BftInput
									required
									type={"text"}
									name={`${namePrefix}.telefonoSoggettoPreposto`}
									placeholder={"Cellulare preposto*"}
									value={values?.telefonoSoggettoPreposto}
									onChange={handleChange}
									onBlur={handleBlur}
									isInvalid={
										!!errors?.telefonoSoggettoPreposto && touched?.telefonoSoggettoPreposto
									}
								/>
								{errors?.telefonoSoggettoPreposto && touched?.telefonoSoggettoPreposto && (
									<Form.Control.Feedback className="ms-3 mb-3" type="invalid">
										{errors?.telefonoSoggettoPreposto}
									</Form.Control.Feedback>
								)}
							</Col>
						</Row>
					)}
				</div>
			)}
		</>
	);
};
export default IndirizziContattiSedeItem;
